import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Table, Pagination, TableActions, TableAction, TableData, TableDataTypes } from '../shared/types';
import { LoaderService } from '../loader.service';
import { AuthService } from '../auth.service';
import { SlabApprovalRequestsService } from './slab-approval-requests.service';
import { ToasterService } from '../toaster.service';
import { Toaster, ToasterType } from '../shared/types/toaster.types';
import { SharedService } from '../shared/shared.service';
import Utils from 'src/app/utils/utils';
import { AUTHZ_FEATURES } from '../constants/permissions';
import { permissionSlugs } from '../auth.service';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var SlabApprovalRequestsComponent = /** @class */ (function () {
    function SlabApprovalRequestsComponent(approvalRequestsService, loaderService, router, accessRights, toastService, sharedService, authzAccessHintService) {
        this.approvalRequestsService = approvalRequestsService;
        this.loaderService = loaderService;
        this.router = router;
        this.accessRights = accessRights;
        this.toastService = toastService;
        this.sharedService = sharedService;
        this.authzAccessHintService = authzAccessHintService;
        this.authzAccessHint = null;
        this.selectedStatus = 'pending';
        this.listFilters = {
            requestStatus: 'PENDING'
        };
        this.sort = {};
        this.table = new Table({
            headers: {
                active: 'Status',
                cities: 'City',
                shift: 'Shift',
                serviceNames: 'Service',
                createdBy: 'Created By',
                startDate: 'Start Date',
                createdDate: 'Created Date',
                isFallbackSlab: 'Fallback Slab',
                poolConfig: 'Pool Configuration',
                action: 'Actions'
            },
            sortableColumnKeys: ['startDate'],
            pagination: new Pagination(0, 15, 150, [15, 20]),
            data: []
        });
        this.cities = [];
        this.serviceIdToName = {};
    }
    SlabApprovalRequestsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchAllCities()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchTableData()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadAccessHint()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('slab')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.fetchAllCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var citiesRes;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return _this.sharedService.fetchCities().toPromise(); })];
                    case 1:
                        citiesRes = _a.sent();
                        this.cities = citiesRes.data.cities;
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.fetchTableData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var permissions, permissionSlugs, response, rows;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.accessRights.getPermissions()];
                                    case 1:
                                        permissions = _a.sent();
                                        permissionSlugs = this.accessRights.normalizePermissionSlugs(permissions);
                                        return [4 /*yield*/, this.approvalRequestsService.fetchApprovalRequests({
                                                pageNumber: this.table.pagination.pageNo,
                                                pageLimit: this.table.pagination.perPage,
                                                requestStatus: this.listFilters.requestStatus,
                                                sortBy: this.sort.sortBy,
                                                sortOrder: this.sort.sortOrder,
                                            }).toPromise()];
                                    case 2:
                                        response = _a.sent();
                                        this.table.pagination.count = response.documentCount || 0;
                                        rows = response.data || [];
                                        return [4 /*yield*/, this.enrichServiceNameCacheForSlabs(rows.map(function (row) { return row.newValue || {}; }))];
                                    case 3:
                                        _a.sent();
                                        this.table.data = rows.map(function (row) {
                                            var slab = row.newValue || {};
                                            var cities = slab.cities || [];
                                            var shift = Array.isArray(slab.shift) ? slab.shift : (slab.shift != null ? [slab.shift] : []);
                                            return {
                                                _id: row._id,
                                                requestStatus: row.requestStatus,
                                                createdBy: row.createdBy,
                                                resourceId: row.resourceId,
                                                resource: row.resource,
                                                key: row.key,
                                                version: row.version,
                                                newValue: slab,
                                                oldValue: row.oldValue || null,
                                                active: _this.formatRequestStatus(row.requestStatus),
                                                cities: _this.formatCityNames(cities),
                                                shift: shift.join(', '),
                                                serviceNames: _this.formatServiceNames(slab),
                                                startDate: slab.startDate,
                                                createdDate: _this.formatCreatedDate(row.createdOn),
                                                isFallbackSlab: slab.isFallbackSlab ? 'Yes' : 'No',
                                                poolConfig: Utils.formatPoolConfigFromSlab(slab),
                                                action: _this.createViewAction(row),
                                            };
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.formatCityNames = function (cityRefs) {
        var _this = this;
        return (cityRefs || [])
            .map(function (ref) {
            var city = _this.cities.find(function (c) {
                return String(c._id) === String(ref) || c.displayName === ref;
            });
            return city ? city.displayName : ref;
        })
            .join(', ');
    };
    SlabApprovalRequestsComponent.prototype.enrichServiceNameCacheForSlabs = function (slabs) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cityObjs, _i, slabs_1, slab, refs, _loop_1, this_1, _a, refs_1, ref;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cityObjs = [];
                        for (_i = 0, slabs_1 = slabs; _i < slabs_1.length; _i++) {
                            slab = slabs_1[_i];
                            refs = slab.cities || [];
                            _loop_1 = function (ref) {
                                var city = this_1.cities.find(function (c) {
                                    return String(c._id) === String(ref) || c.displayName === ref;
                                });
                                if (city && !cityObjs.some(function (c) { return String(c._id) === String(city._id); })) {
                                    cityObjs.push(city);
                                }
                            };
                            this_1 = this;
                            for (_a = 0, refs_1 = refs; _a < refs_1.length; _a++) {
                                ref = refs_1[_a];
                                _loop_1(ref);
                            }
                        }
                        return [4 /*yield*/, Promise.all(cityObjs.map(function (city) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var res, raw, serviceDetails, _i, serviceDetails_1, serviceDetail, name_1, error_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.sharedService.fetchServices(city._id).toPromise()];
                                        case 1:
                                            res = _a.sent();
                                            raw = res && res.data;
                                            serviceDetails = Array.isArray(raw) ? raw : Object.values(raw || {});
                                            for (_i = 0, serviceDetails_1 = serviceDetails; _i < serviceDetails_1.length; _i++) {
                                                serviceDetail = serviceDetails_1[_i];
                                                name_1 = serviceDetail.service && serviceDetail.service.name;
                                                if (name_1 && serviceDetail._id) {
                                                    this.serviceIdToName[String(serviceDetail._id)] = name_1;
                                                }
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.formatServiceNames = function (slab) {
        var _this = this;
        var names = slab && slab.serviceNames;
        if (Array.isArray(names) && names.length > 0) {
            return names.join(', ');
        }
        var ids = (slab && (slab.serviceTypes || slab.serviceDetailIds)) || [];
        if (!Array.isArray(ids) || !ids.length) {
            return '';
        }
        return ids.map(function (id) { return _this.serviceIdToName[String(id)] || id; }).join(', ');
    };
    SlabApprovalRequestsComponent.prototype.formatCreatedDate = function (createdOn) {
        if (!createdOn) {
            return '';
        }
        var num = Number(createdOn);
        if (!isNaN(num) && num > 1000000000) {
            var date = new Date(num);
            return date.toISOString().split('T')[0];
        }
        var raw = typeof createdOn === 'string' ? createdOn : String(createdOn);
        return raw.split('T')[0];
    };
    SlabApprovalRequestsComponent.prototype.formatRequestStatus = function (status) {
        if (!status) {
            return '';
        }
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };
    SlabApprovalRequestsComponent.prototype.createViewAction = function (row) {
        var _this = this;
        var actionArr = [];
        var canView = this.accessRights.isAuthorizedFor(permissionSlugs(AUTHZ_FEATURES.SLAB, ['view', 'create', 'approve'], this.accessRights.getAuthzPanels()), AUTHZ_FEATURES.SLAB);
        if (canView) {
            actionArr.push(new TableAction({
                onClick: function () { return _this.openPreview(row); },
                text: 'View'
            }));
        }
        return new TableData({
            actions: new TableActions(actionArr),
            type: TableDataTypes.ACTION
        });
    };
    SlabApprovalRequestsComponent.prototype.openPreview = function (row) {
        var requestId = row && row._id;
        if (!requestId) {
            this.toastService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Approval request id is missing.'
            }));
            return;
        }
        this.approvalRequestsService.storePreviewForRequest(requestId, {
            requestId: requestId,
            requestStatus: row.requestStatus,
            operation: row.operation,
            createdBy: row.createdBy,
            statusChangedBy: row.statusChangedBy,
            resourceId: row.resourceId,
            resource: row.resource,
            key: row.key,
            version: row.version,
            newValue: row.newValue || {},
            oldValue: row.oldValue || null,
        });
        this.router.navigate(['/slab-approval-requests', requestId], { queryParams: { preview: 'approval' } });
    };
    SlabApprovalRequestsComponent.prototype.sortByHeader = function (header) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sortOrder, column;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sortOrder = header.includes('-') ? -1 : 1;
                        column = header.replace('-', '');
                        if (column !== 'startDate') {
                            return [2 /*return*/];
                        }
                        this.sort = { sortBy: column, sortOrder: sortOrder };
                        this.table.pagination.setPageNoToZero();
                        return [4 /*yield*/, this.fetchTableData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlabApprovalRequestsComponent.prototype.onStatusChange = function () {
        this.table.pagination.setPageNoToZero();
        var statusMap = {
            all: undefined,
            pending: 'PENDING',
            approved: 'APPROVED',
            rejected: 'REJECTED',
        };
        this.listFilters.requestStatus = statusMap[this.selectedStatus];
        this.fetchTableData();
    };
    SlabApprovalRequestsComponent.prototype.withLoader = function (cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, cb()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return SlabApprovalRequestsComponent;
}());
export { SlabApprovalRequestsComponent };
